import { Result } from './result';

export type EventCallback = (result: Result) => void;
